module.exports = __webpack_public_path__ + "img/login_picture.c13d8974.png";